import React, { useEffect } from "react";
import { EditorDashboardSidebar } from "../Sidebar/EditorDashboardSidebar";
import EditorDashboardHeader from "../Header/EditorDashboardHeader";
import styles from '../../styles/layout/editor-dashboard-wrapper.module.scss'
import { Box, Stack } from "@mui/material";
import UserCopyWriterFooter from "../UserFooter/UserCopyWriterFooter";
import { parseCookies } from "nookies";
import { useNavigate } from "react-router";

export default function EditorDashboardWrapper(props) {
    const cookies = parseCookies();
    const savedrole_Id = cookies?.role_id;
  
    const nav = useNavigate();
  
    useEffect(() => {
      if (savedrole_Id != 4) {
      //   <Navigate to="/page404" />;
    //   nav("/page404")
    nav("/login");
      }
    }, [savedrole_Id]);
  
    return (
        <>
            <EditorDashboardHeader />
            <Stack direction={'row'} className={styles.editorDashboardSiderbarBody}>
                <Box className={styles.editorDashboardSidebar}><EditorDashboardSidebar /></Box>
                <Box className={styles.editorDashboardBody}>{props.children}</Box>
            </Stack>
            <UserCopyWriterFooter footerChatBtn={props.chatbtn} />
        </>
    );
}